"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _spot = _interopRequireDefault(require("@/mixins/spot"));
var _keyword = _interopRequireDefault(require("@/components/base/keyword.vue"));
var _index = _interopRequireDefault(require("@/components/Tinymce/index"));
var _default2 = require("@/views/scenic-spot/creatProduct/default");
var _scenicSpot = require("@/api/scenic-spot");
var _vuex = require("vuex");
var _auth = require("@/utils/auth");
var _ZBKJIutil = require("@/utils/ZBKJIutil");
var _permission = require("@/utils/permission");
var _mapService = _interopRequireDefault(require("@/utils/mapService"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// 权限判断函数
var _default = exports.default = {
  mixins: [_spot.default],
  //此js存放商品的部分函数方法
  components: {
    Tinymce: _index.default,
    keyword: _keyword.default
  },
  data: function data() {
    return {
      upload: {
        videoIng: false // 是否显示进度条；
      },
      myHeaders: {
        'X-Token': (0, _auth.getToken)()
      },
      form: {
        scenicAreaId: null,
        scenicName: '',
        address: '',
        location: [],
        spotPhone: '',
        admissionStartTime: '',
        image: '',
        imagePageList: [],
        // 改为数组，支持多图
        blurb: '',
        audioGuideUrl: '',
        tags: [],
        sort: null,
        delFlag: 0,
        remark: ''
      },
      isEdit: false,
      scenicAreaArr: [],
      labelarr: [],
      title: '',
      proTypedialogVisible: false,
      //景点新增弹窗
      rules: {
        image: [{
          required: true,
          message: '请上传景点图片',
          trigger: 'change'
        }],
        flatPattern: [{
          required: true,
          message: '请输入展示图地址',
          trigger: 'blur'
        }],
        sliderImages: [{
          required: true,
          message: '请上传景点详情图',
          type: 'array',
          trigger: 'change'
        }],
        scenicName: [{
          required: true,
          message: '请输入景点名称',
          trigger: 'blur'
        }],
        intro: [{
          required: true,
          message: '请输入景点简介',
          trigger: 'blur'
        }],
        keyword: [{
          required: true,
          message: '请输入关键词',
          trigger: 'blur'
        }],
        price: [{
          required: true,
          message: '请输入景点价格',
          trigger: 'blur'
        }]
      }
    };
  },
  computed: _objectSpread({}, (0, _vuex.mapGetters)(['merProductClassify'])),
  mounted: function mounted() {
    if (!localStorage.getItem('merProductClassify') && (0, _permission.checkPermi)(['merchant:product:category:cache:tree'])) this.$store.dispatch('product/getMerProductClassify');
    this.initData();
  },
  methods: {
    initData: function () {
      var _initData = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return (0, _scenicSpot.areaLstApi)();
            case 1:
              res = _context.v;
              this.scenicAreaArr = res.list;
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function initData() {
        return _initData.apply(this, arguments);
      }
      return initData;
    }(),
    //视频上传前
    beforeAvatarUpload: function beforeAvatarUpload(file) {
      return true;
      var isJPG = file.type === 'video/mp4';
      var isLt2M = file.size / 10240 / 10240 < 2;
      if (!isJPG) {
        this.$message.error('上传视频只能是 mp4 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传视频不能超过 20MB!');
      }
      return isJPG && isLt2M;
    },
    handleUploadForm: function () {
      var _handleUploadForm = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(param) {
        var formData, data, loading, res, _t;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              formData = new FormData();
              data = {
                model: 'product',
                pid: 0
              };
              loading = this.$loading({
                lock: true,
                text: '上传中，请稍候...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              });
              formData.append('multipart', param.file);
              _context2.p = 1;
              _context2.n = 2;
              return (0, _ZBKJIutil.uploadImage)(formData, data);
            case 2:
              res = _context2.v;
              this.upload.videoIng = true;
              this.form.audioGuideUrl = res.url;
              this.progress = 100;
              loading.close();
              _context2.n = 4;
              break;
            case 3:
              _context2.p = 3;
              _t = _context2.v;
              loading.close();
            case 4:
              return _context2.a(2);
          }
        }, _callee2, this, [[1, 3]]);
      }));
      function handleUploadForm(_x) {
        return _handleUploadForm.apply(this, arguments);
      }
      return handleUploadForm;
    }(),
    handleTimeChange: function handleTimeChange(value) {
      if (value && value.length === 2) {
        this.form.admissionStartTime = value[0];
        this.form.admissionEndTime = value[1];
      } else {
        this.form.admissionStartTime = '';
        this.form.admissionEndTime = '';
      }
    },
    checkPermi: _permission.checkPermi,
    // 删除景点详情图
    handleRemoveImagePage: function handleRemoveImagePage(index) {
      this.form.imagePageList.splice(index, 1);
    },
    showEdit: function showEdit(row, type) {
      if (row) {
        this.title = '修改景点';
        Object.assign(this.form, JSON.parse(JSON.stringify(row)));
        if (type == 1) {
          this.isEdit = true;
          this.title = '详情';
        } else {
          this.isEdit = false;
        }
        console.log('下面出错了');

        // 处理 imagePage 字段（API返回的是imagePage，需要转换为imagePageList）
        var imagePageArray = [];

        // 优先从 imagePage 字段获取（API返回的字段名）
        var imagePageData = this.form.imagePage || this.form.imagePageList;
        if (Array.isArray(imagePageData)) {
          // 已经是数组，直接使用
          imagePageArray = imagePageData;
        } else if (typeof imagePageData === 'string' && imagePageData) {
          // 如果是字符串格式 "[url1, url2]"，需要解析
          if (imagePageData.startsWith('[') && imagePageData.endsWith(']')) {
            try {
              // 去掉首尾的方括号，按逗号分割，去除空格
              var urls = imagePageData.slice(1, -1).split(',').map(function (url) {
                return url.trim();
              });
              imagePageArray = urls.filter(function (url) {
                return url;
              }); // 过滤空字符串
            } catch (e) {
              console.error('解析 imagePage 失败:', e);
              imagePageArray = [];
            }
          } else {
            // 单个URL字符串
            imagePageArray = [imagePageData];
          }
        }

        // 响应式丢失，重新赋值
        this.form = _objectSpread(_objectSpread({}, this.form), {}, {
          adjust: [this.form.admissionStartTime, this.form.admissionEndTime],
          imagePageList: imagePageArray
        });
        console.log(this.form, '时间回显');
      } else {
        this.isEdit = false;
        this.title = '新增景点';
        // Object.assign(this.form, JSON.parse(JSON.stringify(defaultArea)))
        this.form = JSON.parse(JSON.stringify(_default2.defaultSpot));
        // 确保新增时 imagePageList 是数组
        if (!Array.isArray(this.form.imagePageList)) {
          this.form.imagePageList = [];
        }
        console.log(this.form);
      }
    },
    //选择景点类型确定
    // 保存
    handleSubmit: function handleSubmit() {
      var _this = this;
      if (this.form.adjust) {
        this.form.admissionStartTime = this.form.adjust[0];
        this.form.admissionEndTime = this.form.adjust[1];
      }
      this.$refs['formValidate'].validate(/*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(valid) {
          var location, result, submitData;
          return _regenerator().w(function (_context3) {
            while (1) switch (_context3.n) {
              case 0:
                if (!valid) {
                  _context3.n = 2;
                  break;
                }
                _context3.n = 1;
                return (0, _mapService.default)(_this.form.address);
              case 1:
                location = _context3.v;
                if (location && location.lng && location.lat) {
                  result = location.lng ? [String(location.lng), String(location.lat)] : [];
                  console.log('腾讯地图你解析', location);
                  _this.form.location = result;
                }

                // 准备提交的数据
                submitData = _objectSpread({}, _this.form);
                if (_this.form.id) {
                  (0, _scenicSpot.spotUpdateApi)(submitData).then(function (res) {
                    _this.proTypedialogVisible = false;
                    _this.$emit('success');
                    _this.$message.success('修改成功');
                  });
                } else {
                  (0, _scenicSpot.spotCreateApi)(submitData).then(function (res) {
                    _this.proTypedialogVisible = false;
                    _this.$emit('success');
                    _this.$message.success('新增成功');
                  });
                }
              case 2:
                return _context3.a(2);
            }
          }, _callee3);
        }));
        return function (_x2) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  }
};